import React, {FC, useEffect, useRef, useState} from 'react';
import CloseIcon from "../common/icons/CloseIcon";
import Button from "../common/elements/Button";
import {useAppDispatch, useAppSelector} from "../../store/hooks";
import {getSortingSteps} from "../../utils/content";
import {setOptionsAction} from "../../store/reducers/commonSlice";
import ICommonOptions from "../../types/commonOptions";
import useOutsideAlerter from "../../hooks/UseOutsideAlerter";
import {featureAPI} from "../../api/feature";
import IFeature from "../../types/feature";
import classNames from "classnames";

type TModalProps = {
    children: any
    onClose: () => void
    title?: string
    className?: string
    fullScreen?: boolean
    visible?: boolean
}

const Modal: FC<TModalProps> = ({children, onClose, title = '', className = '', fullScreen = false, visible = true}) => {
    const contentRef = useRef(null)
    useOutsideAlerter(contentRef, onClose)
    const modalRef = useRef(null)

    return (
        <div className={classNames('flex items-center justify-center bg-white fixed top-0 left-0 right-0 z-[150] w-full p-4 overflow-x-hidden overflow-y-auto md:inset-0 h-full max-h-full', {
            'hidden': !visible
        })}>
            <div className={classNames('relative max-w-full max-h-full', {
                'h-full': fullScreen,
                'w-full': fullScreen,
                'w-[700px]': !fullScreen
            })} ref={modalRef}>
                <div className="relative bg-white rounded-lg shadow-md shadow-[0_4px_11px_-2px_#AAAAAA] h-full">
                    <button type="button" onClick={onClose} className="absolute top-0 right-0 text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 ml-auto inline-flex justify-center items-center dark:hover:bg-gray-600 dark:hover:text-white" data-modal-hide="authentication-modal">
                        <CloseIcon />
                    </button>
                    <div className="px-6 py-6 pt-[43px] lg:px-8 h-full">
                        {children}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Modal;